import React, { useContext, useState } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'
import { copyText, getPlatform } from '../../lib/easybake'

import Button from '@react/react-spectrum/Button'
import Heading from '@react/react-spectrum/Heading'
import Checkmark from '@react/react-spectrum/Icon/Checkmark'
import Copy from '@react/react-spectrum/Icon/Copy'
import Well from '@react/react-spectrum/Well'
import CodeSnippetCurl from './CodeSnippetCurl'

export default function WizardHelloWorld () {
    const { page, cred } = useContext(EasybakeContext)
    const [copyStateHelloCurlCommand, setCopyStateHelloCurlCommand] = useState(false)
    const [copyStateSetToken, setCopyStateSetToken] = useState(false)

    function copyActionSetToken(e, target) {
        analytics.sendEventName('click', `${page}:copySetToken`)
        copyText(target, page)
        setCopyStateSetToken(true)
        setTimeout(() => setCopyStateSetToken(false), 600);
    }

    function copyActionHelloCurlCommand(e, target) {
        analytics.sendEventName('click', `${page}:copyHelloCurlCommand`)
        copyText(target, page)
        setCopyStateHelloCurlCommand(true)
        setTimeout(() => setCopyStateHelloCurlCommand(false), 600);
    }

    function getCurlCommandSetToken(e) {
        let curlCommand = `set YOUR_ACCESS_TOKEN=`
        if (getPlatform() === 'mac') {
            curlCommand = `YOUR_ACCESS_TOKEN=`
        }
        return curlCommand
    }

    function getCurlCommand(e) {
        let curlCommand = `curl --request GET --url "${process.env.REACT_APP_CONFIG_APP_IMAGE_API_ENDPOINT}/pie/psdService/hello" --header "Authorization: Bearer %YOUR_ACCESS_TOKEN%" --header "x-api-key: ${cred && cred.apiKey}"`
        if (getPlatform() === 'mac') {
            curlCommand = `curl --request GET \\\n  --url "${process.env.REACT_APP_CONFIG_APP_IMAGE_API_ENDPOINT}/pie/psdService/hello" \\\n  --header "Authorization: Bearer $YOUR_ACCESS_TOKEN" \\\n  --header "x-api-key: ${cred && cred.apiKey}"`
        }
        return curlCommand
    }

    return (
        <div className="adobe-easybake-main-wizard">
            <div className="adobe-easybake-flex-row"><Heading variant="subtitle1">{__('console_credinfo_hello_curl_command_title')}</Heading></div>
            <div className="adobe-easybake-p-cred">{ getPlatform()==="mac" ? __('console_credinfo_generate_hello_desc') : __('console_credinfo_generate_hello_desc_win')}</div>
            <br />
            <Well>
                <div className='adobe-easybake-sp-access-token-title'>
                    <div className='adobe-easybake-sp-access-token-subtitle'>{__("signup_wizard_curl_title_hello")}</div>
                    <div className="adobe-easybake-credinfo-button">
                        { copyStateHelloCurlCommand ? <Button
                            style={{
                            alignItems: 'center',
                            backgroundColor: '#12805C',
                            padding: '0px 36px'
                            }}
                            icon={<Checkmark style={{color: '#ffffff'}} />}
                            variant="action"
                        /> : <Button variant="action"
                            icon={<Copy />}
                            onClick={ e => copyActionHelloCurlCommand(e, getCurlCommand()) }>{__('console_credinfo_btn_copy')}
                        </Button>}
                    </div>
                </div>
                <div className="adobe-easybake-code-preview-curl">
                    <CodeSnippetCurl language="json" text={getCurlCommand()}/>
                </div>
            </Well>
        </div>
    )
}
